import { encryption } from "@/lib/encryption/encryption";
import { setCookie, getCookie, deleteCookie } from "cookies-next/client";
import { getCookie as getCookieServer } from "cookies-next/server";
import { IncomingMessage } from "http";
import { NextRequest } from "next/server";
import { ReadonlyRequestCookies } from "next/dist/server/web/spec-extension/adapters/request-cookies";

interface CookieOptions {
  expires?: number; // days
  secure?: boolean;
  httpOnly?: boolean;
  path?: string;
  encrypt?: boolean;
  sameSite?: "strict" | "lax" | "none";
  domain?: string;
}

const DEFAULT_OPTIONS: CookieOptions = {
  expires: 7,
  secure: process.env.NODE_ENV === "production",
  httpOnly: false,
  path: "/",
  encrypt: false,
  sameSite: "lax",
};

export const cookieService = {
  encryption: encryption,

  set(key: string, value: string, options: CookieOptions = {}) {
    const opts = { ...DEFAULT_OPTIONS, ...options };
    const valueToStore = opts.encrypt ? this.encryption.encrypt(value) : value;

    if (opts.sameSite === "none") {
      opts.secure = true;
    }

    setCookie(key, valueToStore, {
      maxAge: opts.expires ? opts.expires * 24 * 60 * 60 : 30 * 24 * 60 * 60,
      secure: opts.secure,
      path: opts.path,
      httpOnly: opts.httpOnly,
      sameSite: opts.sameSite,
      domain: opts.domain,
    });

    return valueToStore;
  },

  get(key: string, options: CookieOptions = {}) {
    const opts = { ...DEFAULT_OPTIONS, ...options };
    const value = getCookie(key);

    if (!value) return null;

    // if (opts.encrypt && !this.encryption.isEncrypted(value.toString())) {
    //   return null;
    // }

    // if (!opts.encrypt && this.encryption.isEncrypted(value.toString())) {
    //   try {
    //     return this.encryption.decrypt(value.toString());
    //   } catch {
    //     return value;
    //   }
    // }

    return opts.encrypt ? this.encryption.decrypt(value.toString()) : value;
  },

  remove(key: string, options: CookieOptions = {}) {
    const opts = { ...DEFAULT_OPTIONS, ...options };

    deleteCookie(key, {
      path: opts.path,
      domain: opts.domain,
    });
  },

  // async setServer(
  //   key: string,
  //   value: string,
  //   res?: OutgoingMessage,
  //   options: CookieOptions = {}
  // ) {
  //   const opts = { ...DEFAULT_OPTIONS, ...options };
  //   const valueToStore = opts.encrypt ? this.encryption.encrypt(value) : value;

  //   if (opts.sameSite === "none") {
  //     opts.secure = true;
  //   }

  //   return setCookieServer(key, valueToStore, {
  //     maxAge: opts.expires ? opts.expires * 24 * 60 * 60 : 30 * 24 * 60 * 60,
  //     secure: opts.secure,
  //     path: opts.path,
  //     httpOnly: opts.httpOnly,
  //     sameSite: opts.sameSite,
  //   });
  // },

  async getServer(
    key: string,
    cookieRequest?: (() => Promise<ReadonlyRequestCookies>) | undefined,
    req?: IncomingMessage | NextRequest,
    options: CookieOptions = {},
  ) {
    const cookies = cookieRequest;
    const value = await getCookieServer(key, { cookies });
    if (!value) return null;

    // if (options.encrypt && !this.encryption.isEncrypted(value.toString())) {
    //   return null;
    // }

    // if (!options.encrypt && this.encryption.isEncrypted(value.toString())) {
    //   try {
    //     return this.encryption.decrypt(value.toString());
    //   } catch {
    //     return value;
    //   }
    // }

    return options.encrypt ? this.encryption.decrypt(value.toString()) : value;
  },
};
